import { z } from "zod";
import { BusinessGraphEntrySourceV1Schema, BusinessGraphEntryVerificationV1Schema, } from "./business-graph-entry-state.js";
/** Capture methods beyond thin external SCANNED/IMPORTED/CONFIRMED. */
export const BusinessGraphCaptureMethodV1Schema = z.enum([
    "intake-form",
    "agency-edit",
    "import-html",
    "import-confirmed",
    "enrichment-stub",
    "thin-default",
    "scanned",
    "imported",
    "confirmed",
]);
export const BusinessGraphFactProvenanceV1Schema = z
    .object({
    id: z.string().min(1),
    fieldPath: z.string().min(1),
    source: BusinessGraphEntrySourceV1Schema,
    captureMethod: BusinessGraphCaptureMethodV1Schema,
    actorId: z.string().min(1).optional(),
    capturedAt: z.string().datetime(),
    confidence: z.number().min(0).max(1).optional(),
    reviewState: BusinessGraphEntryVerificationV1Schema,
    sourceRef: z.string().min(1).optional(),
    reviewDecision: z
        .enum(["CONFIRMED", "REJECTED", "EDITED", "NEEDS_PROOF", "DEFERRED"])
        .optional(),
    /** BG-004: required when clarify-with-reason / NEEDS_PROOF. */
    reviewReason: z.string().min(1).max(2000).optional(),
})
    .strict();
export const BusinessGraphProvenanceDomainV1Schema = z
    .object({
    records: z.array(BusinessGraphFactProvenanceV1Schema).default([]),
})
    .strict();
export function provenanceRecordId(fieldPath) {
    return `prov_${fieldPath.replace(/[^a-zA-Z0-9._-]+/g, "_")}`;
}
export function upsertFactProvenance(records, next) {
    const id = next.id || provenanceRecordId(next.fieldPath);
    const record = { ...next, id };
    const filtered = records.filter((r) => r.fieldPath !== record.fieldPath && r.id !== record.id);
    filtered.push(record);
    return filtered;
}
//# sourceMappingURL=business-graph-provenance.js.map